import * as React from "react";
import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { Button } from "semantic-ui-react";

import { BookAppointmentTaskListModel, ChooseAndBookStatus } from "../models";

interface Props {
    task: BookAppointmentTaskListModel;
    onClick: (task: BookAppointmentTaskListModel) => void;
}
export class ChooseAndBookButton extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    public render() {
        if (this.props.task.chooseAndBookStatus === ChooseAndBookStatus.None) {
            return (
                <ConfirmedButton
                    content="Choose and Book"
                    promptText="Are you sure you wish to invite the employee to choose and book this appointment?"
                    onClick={this.onClick}
                    compact
                    primary
                    confirmButtonColor="green"
                />);
        } else if (this.props.task.chooseAndBookStatus === ChooseAndBookStatus.TimeoutExpired) {
            return <Button content="Choose and Book expired" negative compact />;
        } else {
            return <Button content="Choose and Book requested" primary compact />;
        }
    }

    public onClick() {
        this.props.onClick(this.props.task);
    }
}
